import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgIncomingCall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 17 17"
    fill="#00C253"
    {...props}
  >
    <path d="m15.068.407 1.153 1.027c.871.772 1.012 1.864.421 3.277-.884 2.118-4.2 7.225-11.423 11.543-1.595 1.117-3.026.865-3.683 0a89.48 89.48 0 0 0-1.29-1.657c-.467-.719-.27-1.386.592-2.002 1.291-.923.878-.598 1.935-1.32 1.054-.72 1.046-.558 2.446 0 1.4.561 1.413 1.048 2.8-.27.925-.88 2.11-2.08 3.555-3.604.542-.508.542-1.14 0-1.899-.813-1.138-.813-1.575 0-2.82A23.62 23.62 0 0 1 13.248.406c.602-.542 1.208-.542 1.821 0Z" />
  </svg>
);
const Memo = memo(SvgIncomingCall);
export default Memo;
